// extracted by mini-css-extract-plugin
export default {"card":"ContactCard_card__jQVG1","title":"ContactCard_title__C4Fu1","triangle":"ContactCard_triangle__VooGY","icon":"ContactCard_icon__amO+t"};